XA.component.collection = (function ($, document) {
    var api = {};
    api.initInstance = function () {


        //TABS
        var collectionTitle = $('.collection.frames .field-title');

        //set the activity for the first element
        $('.collection.frames .item-frame').eq(0).addClass('open');

        $(collectionTitle).on('click', function(){
            if($(this).closest('.item-frame').hasClass('open')){
                $(this).closest('.item-frame').removeClass('open');
            }else{
                $(this).closest('.item-frame').siblings().removeClass('open');
                $(this).closest('.item-frame').addClass('open');
            }
        });

 

    };

    api.init = function () {
        api.initInstance();
    };
    return api;
})(jQuery, document);
XA.register("collection", XA.component.collection);